import {
	mdiAccountBoxMultiple,
	mdiBellOutline,
	mdiCodeGreaterThanOrEqual,
	mdiCogOutline,
	mdiHome,
	mdiLightningBolt,
	mdiMessage,
	mdiNewspaperVariantMultipleOutline,
	mdiShoppingOutline,
	mdiChartBar,
	mdiTools,
	mdiTranslate,
	mdiLightbulbOutline,
	mdiRobotOutline,
	mdiVideoAccount,
} from '@mdi/js'

// Array of sections

export default [
	{
		icon: mdiHome,
		title: 'Dashboard',
		to: 'ai-dashboard',
	},
	{
		icon: mdiRobotOutline,
		title: 'menu.aiStatus',
		to: 'ai-providers-status',
	},
	{
		icon: mdiRobotOutline,
		title: 'menu.aiModels',
		to: 'network-ai-models',
	},
	{
		icon: mdiRobotOutline,
		title: 'aiAgents.menu.group',
		module: 'MGAI,agents',
		children: [
			{
				title: 'aiAgents.menu.runs',
				to: 'ai-agent-runs-list',
			},
			{
				title: 'aiAgents.menu.agents',
				to: 'ai-agents-list',
			},
			{
				title: 'aiAgents.menu.settings',
				to: 'ai-settings-list',
			},
		],
	},
	{
		icon: mdiMessage,
		title: 'menu.messages',
		to: 'ai-messages-list',
		module: 'MGAI,messages',
	},
	{
		icon: mdiNewspaperVariantMultipleOutline,
		title: 'Newsletter',
		to: 'ai-newsletter-list',
		module: 'MGAI,newsletter',
	},
	{
		title: 'menu.profiles',
		icon: mdiAccountBoxMultiple,
		module: 'MGAI,profiles',
		children: [
			{
				title: 'menu.profiles',
				to: 'ai-profiles-list',
			},
			{
				title: 'menu.profilesCategories',
				to: 'ai-profiles-categories-list',
			},
		],
	},
	{
		icon: mdiVideoAccount,
		title: 'menu.ugcPersonas',
		to: 'ai-ugc-personas-list',
		module: 'MGAI,profiles',
	},
	{
		icon: mdiTranslate,
		title: 'menu.languageModel',
		to: 'ai-language-model-list',
		module: 'MGAI,language-model',
	},
	{
		icon: mdiTools,
		title: 'menu.services',
		to: 'ai-services-list',
		module: 'MGAI,services',
	},
	{
		icon: mdiCodeGreaterThanOrEqual,
		title: 'menu.tokenConfigs',
		to: 'ai-token-configs-list',
		module: 'MGAI,token-configs',
	},
	{
		icon: mdiLightningBolt,
		title: 'ai.quickPrompts.list.title',
		to: 'ai-quick-prompts-list',
		module: 'MGAI,quick-prompts',
	},
	{
		icon: mdiShoppingOutline,
		title: 'Marketplace',
		to: 'ai-marketplace-list',
		module: 'MGAI,marketplace',
	},
	{
		icon: mdiChartBar,
		title: 'Usage',
		to: 'ai-usage-list',
		module: 'MGAI,usage',
	},
	{
		icon: mdiLightbulbOutline,
		title: 'ai.insights.list.title',
		to: 'ai-insights-list',
		module: 'MGAI,marketplace',
	},
	{
		icon: mdiCogOutline,
		title: 'Assistant Config',
		to: 'ai-assistant-config',
		module: 'MGAI,profiles',
	},
	{
		icon: mdiBellOutline,
		title: 'notifications.notifications',
		module: 'MGAI,notifications',
		children: [
			{
				title: 'menu.notifications.list',
				to: 'ai-notifications-list',
			},
			{
				title: 'menu.notifications.templates',
				to: 'network-notification-templates-list',
			},
		],
	},
]
